const Order = {
  id: 'ProductSchema',
  type: 'object',
  required: [
    'productName',
    'productCategoryID',
    'productBrand',
    'productImage',
    'productWeight',
    'productLong',
    'productWide',
    'productHeight',
    'productSubDetail',
    'productDetail',
    'productCost',
    'productPrice',
    'productQTY',
    'productMinimumInventory'
  ],
  properties: {
    productName: {
      type: 'string',
      minLength: 3,
      maxLength: 150
    },
    productCategoryID: {
      type: 'string'
    },
    productBrand: {
      type: 'string',
      minLength: 3,
      maxLength: 150
    },
    productImage: {
      type: 'string'
    },
    productWeight: {
      type: 'number',
      minimum: 1,
      maximum: 99999
    },
    productLong: {
      type: 'number',
      minimum: 1,
      maximum: 99999
    },
    productWide: {
      type: 'number',
      minimum: 1,
      maximum: 99999
    },
    productHeight: {
      type: 'number',
      minimum: 1,
      maximum: 99999
    },
    productSubDetail: {
      type: 'string',
      minLength: 3,
      maxLength: 150
    },
    productDetail: {
      type: 'string',
      minLength: 3
    },
    productCost: {
      type: 'number',
      minimum: 1,
      maximum: 9999999999
    },
    productPrice: {
      type: 'number',
      minimum: 1,
      maximum: 9999999999
    },
    productQTY: {
      type: 'number',
      minimum: 1,
      maximum: 9999999999
    },
    productMinimumInventory: {
      type: 'number',
      minimum: 1,
      maximum: 9999999999
    },
    id: {
      type: 'string'
    }
  }
};

export default Order;
